export default "__VITE_PUBLIC_ASSET__789a6c79__"